import Model from './Model';
import Screen from '../utils/Screen';
import { isFlexibleSearchFlagActive } from '../utils/features';

export default class Search extends Model {
    static isMobileAndFlexibleSearchActive = () => isFlexibleSearchFlagActive() && Screen.isMobile();
}
